const getEnvVariable = ev => {
    if (!process.env[ev]) {
        console.error(`Please add ${ev} to .env file`);
    }

    return process.env[ev];
};

export default getEnvVariable;
